import { FontVariant } from "@/constants/theme";
import { type FieldType } from "./index";
import type { Theme } from "@/types/theme";

export function getDefaultFontVariant(theme: Theme, type: FieldType) {
  const {
    siteBuilder: {
      fontSettings: { preTitle, title, subTitle, intro, outro },
    },
  } = theme;

  switch (type) {
    case "pre-title":
      return preTitle.value;

    case "title":
      return title.value;

    case "sub-title":
      return subTitle.value;

    case "intro":
      return intro.value;

    case "outro":
      return outro.value;

    case "text-x-small":
      return FontVariant.BodyXSmall;

    case "text-small":
      return FontVariant.BodySmall;

    case "text-regular":
      return FontVariant.BodyRegular;

    case "text-large":
      return FontVariant.BodyLarge;

    case "text-x-large":
      return FontVariant.BodyXLarge;

    case "text-xx-large":
      return FontVariant.BodyXXLarge;

    case "bullet-points":
      return FontVariant.BulletPoints;

    case "pull-quote":
      return FontVariant.PullQuote;

    case "header-h1":
      return FontVariant.HeaderH1;

    case "header-h2":
      return FontVariant.HeaderH2;

    case "header-h3":
      return FontVariant.HeaderH3;

    case "header-h4":
      return FontVariant.HeaderH4;

    case "header-h5":
      return FontVariant.HeaderH5;

    case "header-h6":
      return FontVariant.HeaderH6;
  }
}
